import {logger} from './logger'
import {Time} from './time'

export type TimeUnit = 'day' | 'month' | 'week'

export interface RelativeTime {
  value: number
  unit: TimeUnit
}

const day = 24 * 3600_000

export const relativeTimeToTimestamp = (
  t: RelativeTime,
  from: number | 'now'
): number => {
  const t0 = !from || from === 'now' ? Time.now() : from
  if (!t) {
    return t0
  }
  if (t.unit === 'day') {
    return Time.startOfDay(t0) + t.value * day
  } else if (t.unit === 'week') {
    return Time.startOfWeek(t0) + t.value * 7 * day
  } else if (t.unit === 'month') {
    const d = Time.toLocalDate(t0)
    d.setMonth(d.getMonth() + t.value)
    return Time.startOfMonth(Time.toTimestamp(d))
  } else {
    logger.error('Incorrect unit', t.unit)
    return t0
  }
}
